import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Key, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const AUTH_BG =
  "https://images.unsplash.com/photo-1724582586458-a51791349977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg3NDA4NTQ0fDA&ixlib=rb-4.1.0&q=85";

export default function AdminLogin() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    try {
      await api.post("/admin/login", { code: code.trim() });
      sessionStorage.setItem("admin_code", code.trim());
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden" data-testid="admin-login-page">
      <img
        src={AUTH_BG}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#1A1A18]/55" />

      <div className="relative z-10 flex min-h-screen items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-md rounded-2xl border border-white/40 bg-white/90 p-10 backdrop-blur-xl"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            INERRE bespoke
          </p>
          <h1 className="mt-3 font-serif text-5xl font-light tracking-tighter text-foreground">
            Showroom Tour
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            Curated showroom routes for your clients. Enter the admin access code
            to manage tours.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div className="relative">
              <Key className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                data-testid="access-code-input"
                type="password"
                placeholder="Access code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="h-12 rounded-full border-border bg-white pl-11 pr-4 focus-visible:ring-primary"
              />
            </div>
            <Button
              data-testid="access-code-submit"
              type="submit"
              disabled={loading}
              className="h-12 w-full rounded-full bg-primary text-primary-foreground transition-transform duration-200 hover:scale-[1.02] hover:bg-primary"
            >
              {loading ? "Checking…" : "Enter Studio"}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
